module.exports = __webpack_public_path__ + "img/zwischenzeiten.bc95ed67.jpg";